import React from 'react';
import RateTable from './rates-table/rate-table.jsx';
import Discount from './rates-table/discount.jsx';
import R from 'ramda';
import { connect } from 'react-redux';
import { FontIcon } from 'material-ui';

const checkIfSeasonRateWithNotEmptyRateSets = (extraProps, rateType) => extraProps.rateSets[rateType];

const SingleRatesInfo = ({ updateType, rateType, ...extraProps }) => {
  const subTitleName = R.cond([
    [R.equals('seasonRates'), R.always('seasonName')],
    [R.equals('extras'), R.always('extraType')],
    [R.equals('offers'), R.always('offerName')],
    [R.T, R.always('seasonName')],
  ])(updateType);

  if (R.equals(updateType, 'seasonRates')) {
    if (!checkIfSeasonRateWithNotEmptyRateSets(extraProps, rateType)) return <div/>;
    return (
      <div>
        {
          extraProps[subTitleName] !== 'All Year' ? (
            <div style={{ height: '32px', lineHeight: '32px', textTransform: 'uppercase', color: 'rgba(0, 0, 0, 0.54)', borderBottom: 'solid 1px #eeeeee' }}>
              <b style={{
                display: 'inline-block',
                marginLeft: '5px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              >{ extraProps[subTitleName] }</b>
            </div>
          ) : <div/>
        }
        {
          R.compose(
            R.addIndex(R.map)((rateSet, index) => <RateTable {...rateSet} ratePackageName={extraProps.ratePackageName} key={index} />),
            R.propOr([], rateType),
            R.propOr({}, 'rateSets')
          )(extraProps)
        }
      </div>
    );
  }
  return (
    <div>
      <div style={{ height: '48px', lineHeight: '48px', fontSize: '14px', color: 'rgba(0, 0, 0, 0.54)', borderBottom: 'solid 1px #eeeeee' }}>
        <span style={{
          display: 'inline-block',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%',
        }}
        >{ extraProps[subTitleName] }</span>
      </div>
      { R.and(R.equals(rateType, 'discount'), R.equals(updateType, 'offers')) ? <Discount {...extraProps} /> : <RateTable {...extraProps} /> }
    </div>
  );
};

const mapStateToProps = ({ contracting }) => ({
  updateType: contracting.massRateChange.get('updateType'),
  rateType: contracting.massRateChange.get('rateType'),
});

export default connect(mapStateToProps)(SingleRatesInfo);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/single-product/single-rates-info.jsx